import {UserFullReport} from "./UserFullReport";
import {UserFullReportMunicipality} from "./UserFullReportMunicipality";

// С3 — Пълна справка по ползвател (стар s5 URL). Замените са сумирани сървърно.
export const ReportS5 = () => (
    <UserFullReport title="С3 — Пълна справка по ползвател" variant="full" showDeals={true}/>
);

// Ъ16: С3 за цяла община — всички землища с декларация.
export const ReportS5Municipality = () => (
    <UserFullReportMunicipality title="С3 — Пълна справка по ползвател" variant="full" showDeals={true}/>
);
